/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ChargerMeterValueDto } from "./ChargerMeterValueDto";
import {
    ChargerMeterValueDtoFromJSON,
    ChargerMeterValueDtoFromJSONTyped,
    ChargerMeterValueDtoToJSON,
} from "./ChargerMeterValueDto";

/**
 *
 * @export
 * @interface TransactionDto
 */
export interface TransactionDto {
    /**
     *
     * @type {number}
     * @memberof TransactionDto
     */
    transactionId?: number;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    transactionLocalId?: string;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    deviceIdentity?: string;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    deviceType?: TransactionDtoDeviceTypeEnum;
    /**
     *
     * @type {number}
     * @memberof TransactionDto
     */
    connectorIndex?: number;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    connectorIdentity?: string;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    managedBy?: string;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    centralSystemTransactionId?: string;
    /**
     *
     * @type {number}
     * @memberof TransactionDto
     */
    meterStart?: number;
    /**
     *
     * @type {number}
     * @memberof TransactionDto
     */
    meterStop?: number;
    /**
     *
     * @type {number}
     * @memberof TransactionDto
     */
    soCStart?: number;
    /**
     *
     * @type {number}
     * @memberof TransactionDto
     */
    soCEnd?: number;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    idTagStart?: string;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    idTagStop?: string;
    /**
     *
     * @type {number}
     * @memberof TransactionDto
     */
    reservationId?: number;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    odometer?: string;
    /**
     *
     * @type {number}
     * @memberof TransactionDto
     */
    vehicleId?: number;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    vehicleRegistrationPlate?: string;
    /**
     *
     * @type {Date}
     * @memberof TransactionDto
     */
    start?: Date;
    /**
     *
     * @type {Date}
     * @memberof TransactionDto
     */
    end?: Date;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    stopTransactionReason?: string;
    /**
     *
     * @type {Date}
     * @memberof TransactionDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof TransactionDto
     */
    updatedAt?: Date;
    /**
     *
     * @type {number}
     * @memberof TransactionDto
     */
    totalCost?: number;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    currencyCode?: string;
    /**
     *
     * @type {string}
     * @memberof TransactionDto
     */
    billingStatus?: TransactionDtoBillingStatusEnum;
    /**
     *
     * @type {Array<ChargerMeterValueDto>}
     * @memberof TransactionDto
     */
    chargerMeterValues?: Array<ChargerMeterValueDto>;
}

/**
 * @export
 */
export const TransactionDtoDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type TransactionDtoDeviceTypeEnum =
    (typeof TransactionDtoDeviceTypeEnum)[keyof typeof TransactionDtoDeviceTypeEnum];

/**
 * @export
 */
export const TransactionDtoBillingStatusEnum = {
    Unknown: "Unknown",
    NotRequired: "NotRequired",
    Pending: "Pending",
    Raised: "Raised",
    Paid: "Paid",
    Failed: "Failed",
} as const;
export type TransactionDtoBillingStatusEnum =
    (typeof TransactionDtoBillingStatusEnum)[keyof typeof TransactionDtoBillingStatusEnum];

/**
 * Check if a given object implements the TransactionDto interface.
 */
export function instanceOfTransactionDto(
    value: object,
): value is TransactionDto {
    return true;
}

export function TransactionDtoFromJSON(json: any): TransactionDto {
    return TransactionDtoFromJSONTyped(json, false);
}

export function TransactionDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TransactionDto {
    if (json == null) {
        return json;
    }
    return {
        transactionId:
            json["transactionId"] == null ? undefined : json["transactionId"],
        transactionLocalId:
            json["transactionLocalId"] == null
                ? undefined
                : json["transactionLocalId"],
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        connectorIdentity:
            json["connectorIdentity"] == null
                ? undefined
                : json["connectorIdentity"],
        managedBy: json["managedBy"] == null ? undefined : json["managedBy"],
        centralSystemTransactionId:
            json["centralSystemTransactionId"] == null
                ? undefined
                : json["centralSystemTransactionId"],
        meterStart: json["meterStart"] == null ? undefined : json["meterStart"],
        meterStop: json["meterStop"] == null ? undefined : json["meterStop"],
        soCStart: json["soCStart"] == null ? undefined : json["soCStart"],
        soCEnd: json["soCEnd"] == null ? undefined : json["soCEnd"],
        idTagStart: json["idTagStart"] == null ? undefined : json["idTagStart"],
        idTagStop: json["idTagStop"] == null ? undefined : json["idTagStop"],
        reservationId:
            json["reservationId"] == null ? undefined : json["reservationId"],
        odometer: json["odometer"] == null ? undefined : json["odometer"],
        vehicleId: json["vehicleId"] == null ? undefined : json["vehicleId"],
        vehicleRegistrationPlate:
            json["vehicleRegistrationPlate"] == null
                ? undefined
                : json["vehicleRegistrationPlate"],
        start: json["start"] == null ? undefined : new Date(json["start"]),
        end: json["end"] == null ? undefined : new Date(json["end"]),
        stopTransactionReason:
            json["stopTransactionReason"] == null
                ? undefined
                : json["stopTransactionReason"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        totalCost: json["totalCost"] == null ? undefined : json["totalCost"],
        currencyCode:
            json["currencyCode"] == null ? undefined : json["currencyCode"],
        billingStatus:
            json["billingStatus"] == null ? undefined : json["billingStatus"],
        chargerMeterValues:
            json["chargerMeterValues"] == null
                ? undefined
                : (json["chargerMeterValues"] as Array<any>).map(
                      ChargerMeterValueDtoFromJSON,
                  ),
    };
}

export function TransactionDtoToJSON(value?: TransactionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        transactionId: value["transactionId"],
        transactionLocalId: value["transactionLocalId"],
        deviceIdentity: value["deviceIdentity"],
        deviceType: value["deviceType"],
        connectorIndex: value["connectorIndex"],
        connectorIdentity: value["connectorIdentity"],
        managedBy: value["managedBy"],
        centralSystemTransactionId: value["centralSystemTransactionId"],
        meterStart: value["meterStart"],
        meterStop: value["meterStop"],
        soCStart: value["soCStart"],
        soCEnd: value["soCEnd"],
        idTagStart: value["idTagStart"],
        idTagStop: value["idTagStop"],
        reservationId: value["reservationId"],
        odometer: value["odometer"],
        vehicleId: value["vehicleId"],
        vehicleRegistrationPlate: value["vehicleRegistrationPlate"],
        start:
            value["start"] == null ? undefined : value["start"].toISOString(),
        end: value["end"] == null ? undefined : value["end"].toISOString(),
        stopTransactionReason: value["stopTransactionReason"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        totalCost: value["totalCost"],
        currencyCode: value["currencyCode"],
        billingStatus: value["billingStatus"],
        chargerMeterValues:
            value["chargerMeterValues"] == null
                ? undefined
                : (value["chargerMeterValues"] as Array<any>).map(
                      ChargerMeterValueDtoToJSON,
                  ),
    };
}
